<template>
    <form class="uk-grid-small item-answer" uk-grid>
      <div class="uk-width-1-2@s">
          <label class="uk-form-label">Title</label>
          <input class="uk-input" type="text" v-model="item.title">
      </div>
      <div class="uk-width-1-4@s" v-if="type === 'Energy'">
          <label class="uk-form-label">Result</label>
          <input class="uk-input" type="text" v-model="item.result">
      </div>
      <div class="uk-width-1-4@s" v-else>
          <label class="uk-form-label">Option</label>
          <select class="uk-select" v-model="item.option">
              <option value="spring">Spring</option>
              <option value="winter">Winter</option>
              <option value="autumn">Autumn</option>
              <option value="summer">Summer</option>
          </select>
      </div>
      <div class="uk-width-1-4@s uk-align-center">
          <ul class="uk-iconnav uk-text-light">
            <li><a href="#" uk-icon="icon: check" @click.prevent="updateAnswer()" uk-tooltip="Update answer"></a></li>
            <li><a href="#" uk-icon="icon: trash" @click.prevent="deleteAnswer()" uk-tooltip="Delete answer"></a></li>
            <span v-if="message" class="uk-text-small uk-margin-large-right" :class="message.type">{{message.text}}</span>
        </ul>
      </div>
      
    </form>
</template>

<script>
import AnswerService from '@/services/answer.service';
export default {
    name: 'ItemAnswer',
    props: {
      answer: Object,
      type: String,
      number: Number,
      parentId: String
    },
    data() {
      return {
        message: ''
      }
    },
    created() {
      setInterval(() => {
        this.message = null;
      }, 10000)
    },
    computed: {
      item: {
          get() {
            return this.answer;
          },
          set(val) {
             this.answer = val
          }
      }
    },
    methods: {
      deleteAnswer() {
        // Emit  deleteAnswer parent(list-answers)
        this.$emit('delete:answer', this.item._id);
      },
      updateAnswer() {
        AnswerService.update({parentId: this.parentId, answer: this.item}).then(
          res => {
            this.item = res.data.answer;
            this.$emit('update:answer', this.item);
            this.message = {text: res.data.message, type: 'uk-text-success'}
          },
          error => {
            let message = (error.response && error.response.data.message.message) || error.message || error.toString();
            this.message = {text: message, type: 'uk-text-danger'}
          }
        )
      }
    },
}
</script>

<style>
.item-answer{
  margin-left: 20px;;
}
</style>